export * from "modules/IncompleteTyresDashboard/components/EditTyreModal/components/CompleteTyresSearch/hooks/useSearchCompleteTyresQuery";
